import React from 'react';

import PropTypes from 'prop-types';
import { FlexGrid } from '@telus-uds/components-web';

import CategoryGroupItem from './categoryGroupItem';
import EmergencyForms from './emergencyForms';

const CategoryGroup = ({ category, locale, history }) => {
  const { categoryGroupTitle, categoryGroupItems } = category;

  return (
    <FlexGrid.Row>
      <FlexGrid>
        <FlexGrid.Row>
          <FlexGrid.Col>
            <div className="category-group-heading">{categoryGroupTitle}</div>
          </FlexGrid.Col>
        </FlexGrid.Row>
        <div className="category-group-form-container">
          {(categoryGroupItems || []).map(categoryGroupItem => (
            <CategoryGroupItem
              categoryItem={categoryGroupItem}
              locale={locale}
              history={history}
            />
          ))}
          {categoryGroupTitle === 'Other' && <EmergencyForms locale={locale} />}
        </div>
      </FlexGrid>
    </FlexGrid.Row>
  );
};

CategoryGroup.propTypes = {
  category: PropTypes.shape({
    categoryGroupTitle: PropTypes.string,
    categoryGroupItems: PropTypes.arrayOf(
      PropTypes.shape({
        metadata: PropTypes.shape({}),
        sys: PropTypes.shape({}),
        fields: PropTypes.shape({})
      })
    )
  }).isRequired,
  locale: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    go: PropTypes.func
  }).isRequired
};

export default CategoryGroup;
